import { IState, IPropertiesState, ITypesState } from 'types/redux'

export const getUserProperties = ({ settings }: IState): IPropertiesState => settings.userProperties

export const getPostProperties = ({ settings }: IState): IPropertiesState => settings.postProperties

export const getPostTypes = ({ settings }: IState): ITypesState => settings.postTypes

export const getCustomerTypes = ({ settings }: IState): ITypesState => settings.customerTypes